import { atom } from 'jotai';

/**
 * Atom to track if the menu coachmark welcome spotlight is open.
 * Set to true on first qualifying page load when the user hasn't completed the tour.
 */
export const menuCoachmarkWelcomeOpenAtom = atom<boolean>(false);

/**
 * Atom to track the current step of the menu coachmark tour.
 * - 1: Pin button step (Hide sessions to focus)
 * - 2: Hover to reveal step (Your sessions are still here)
 * - 3: Global create step (Start a new session anytime) — conditional
 * - 4: Pin persist step (Keep your sessions visible) — always last
 * - null: No step active (tour not started or completed)
 */
export const menuCoachmarkStepAtom = atom<1 | 2 | 3 | 4 | null>(null);
